import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToTime',
})
export class SecondsToTimePipe implements PipeTransform {
  transform(totalSeconds: number): string {
    if (totalSeconds == null || isNaN(totalSeconds) || totalSeconds < 0) return '-';

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = Math.floor(totalSeconds % 60);

    return [hours, minutes, seconds].map(unit => unit.toString().padStart(2, '0')).join(':');
  }
}
